import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    currentPaymentsAndCollectionsTab: null,
    currentCollectionsTab: null,
    currentBillingsTab: null,
    paystack_api_key: process.env.VUE_APP_PAYSTACK_KEY,
  },
  getters: {
    currentPaymentsAndCollectionsTab: (state) => {
      return state.currentPaymentsAndCollectionsTab;
    },
    currentBillingsTab: (state) => {
      return state.currentBillingsTab;
    },
    currentCollectionsTab: (state) => {
      return state.currentCollectionsTab;
    },
    getPaystackKey: (state)=>{
      return state.paystack_api_key
    }
  },
  mutations: {
    SAVE_CURRENT_PAYMENTS_COLLECTIONS_TAB(state, payload) {
      state.currentPaymentsAndCollectionsTab = payload;
    },
    SAVE_CURRENT_COLLECTIONS_TAB(state, payload) {
      state.currentCollectionsTab = payload;
    },
    SAVE_CURRENT_BILLINGS_TAB(state, payload) {
      state.currentBillingsTab = payload;
    },
  },
  actions: {
    setCurrentPaymentsAndCollectionsTab({ commit }, payload) {
      commit("SAVE_CURRENT_COLLECTIONS_TAB", payload);
    },
    setCurrentCollectionsTab({ commit }, payload) {
      commit("SAVE_CURRENT_PAYMENTS_COLLECTIONS_TAB", payload);
    },
    setCurrentBillingsTab({ commit }, payload) {
      commit("SAVE_CURRENT_BILLINGS_TAB", payload);
    },
  },
};
